
export function setHtml (dom, options) {
  let defaultOptions = {
    minWidth: 1366, // 最小宽
    minHeight: 768, // 最小高
    fontSize: 18, // 参照单位（按视觉图来写）
    visualWidth: 1920, // 视觉图宽
    visualHeight: 943 // 视觉图高
  }
  let _opts = Object.assign(defaultOptions, options)
  let _scope = {
    // 设置字体大小
    setHtmlSize: function () {
      let clientWidth = Math.max(window.innerWidth, _opts.minWidth)
      let clientHeight = Math.max(window.innerHeight, _opts.minHeight)
      let htmlSize = Math.min(clientWidth * _opts.fontSize / _opts.visualWidth, clientHeight * _opts.fontSize / _opts.visualHeight)
      dom.style.fontSize = htmlSize + 'px'
    },
    // 绑定事件
    bindEvent: function () {
      window.addEventListener('resize', _scope.setHtmlSize, false)
    },
    // 解除绑定
    unbindEvent: function () {
      window.removeEventListener('resize', _scope.setHtmlSize, false)
    },
    // 初始化函数
    init: function () {
      _scope.setHtmlSize()
      _scope.bindEvent()
    }
  }
  // 立即执行初始化函数
  _scope.init()
}



// WEBPACK FOOTER //
// ./src/js/common/setHtml.js